var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPocket = function SvgPocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "pocket_svg__svg-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3H4a2 2 0 0 0-2 2v6a10 10 0 0 0 20 0V5a2 2 0 0 0-2-2Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8 10 4 4 4-4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export { SvgPocket as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNMjAgM0g0QzMuNDY5NTcgMyAyLjk2MDg2IDMuMjEwNzEgMi41ODU3OSAzLjU4NTc5QzIuMjEwNzEgMy45NjA4NiAyIDQuNDY5NTcgMiA1VjExQzIgMTMuNjUyMiAzLjA1MzU3IDE2LjE5NTcgNC45Mjg5MyAxOC4wNzExQzUuODU3NTIgMTguOTk5NyA2Ljk1OTkxIDE5LjczNjIgOC4xNzMxNyAyMC4yMzg4QzkuMzg2NDIgMjAuNzQxMyAxMC42ODY4IDIxIDEyIDIxQzE0LjY1MjIgMjEgMTcuMTk1NyAxOS45NDY0IDE5LjA3MTEgMTguMDcxMUMyMC45NDY0IDE2LjE5NTcgMjIgMTMuNjUyMiAyMiAxMVY1QzIyIDQuNDY5NTcgMjEuNzg5MyAzLjk2MDg2IDIxLjQxNDIgMy41ODU3OUMyMS4wMzkxIDMuMjEwNzEgMjAuNTMwNCAzIDIwIDNaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48cGF0aCBkPSJNOCAxMEwxMiAxNEwxNiAxMCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+";